import { observer } from "mobx-react-lite";
import { SectionTab } from "polotno/side-panel";
import { BookOpen02Icon } from "../hugeIcons/hugeIcons";
import { useGlobalContext } from "@src/context/globalContext";
import { Button, Input, Select, message, Popconfirm, Dropdown, Flex, Switch } from "antd";
import { PlayCircleOutlined, PlayCircleFilled, LoadingOutlined, HolderOutlined, PlusOutlined, DeleteOutlined, PauseCircleOutlined, AudioOutlined, StarFilled } from "@ant-design/icons";
import { whisperAiVoiceList } from "@src/data/music";
import React, { useEffect, useRef, useState } from "react";
// import { getAudioDurationInSeconds } from "@remotion/media-utils";
import { aiTextToSpeech, generateCaptions, generateElevenLabsPayloads, getPrevNextText } from "@src/shared/utils/VideoGeneration/audioGeneration";
// import { getDomainID, getToken } from "@src/config/config";
// import { IS_FREE_PLATFORM } from "@src/config";
// import { prefetchAsset } from "@src/shared/utils/remotion";
import { creditsDeduct, getUserDetails } from "@src/shared/utils/VideoGeneration/helperFunctions/mediaSearch";
import { useGetVoices } from "@src/api/elevenLabs/getVoices";
import { VoiceFilterModal } from "@src/features/rightSidebar/audioFilterModal";
import { getClonedVoices } from "@src/shared/utils/VideoGeneration/helperFunctions/voiceCloneApi";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { generateUniqueId } from '@src/shared/utils/core'
import { MdOutlineQueueMusic } from 'react-icons/md';
import { Label } from '@src/features/rightSidebar/captions/captionsPanel';
import { TagSelect } from '@src/shared/components/filters/tagSelect';
import { transitionAnimationsDropDown } from '@src/data/transitions';
import './customScriptPanel.less';

const { TextArea } = Input;

const ScriptVoiceSection = observer(({ section, index, store, aiVoice, voiceOverVolume, videoStyle, clonedVoices }: any) => {
  const [audioElement, setAudioElement] = useState<HTMLAudioElement | null>(null);
  const [isAiAudioLoading, setIsAiAudioLoading] = useState(false);
  const [selectedVoiceName, setSelectedVoiceName] = useState(section?.name || '');
  const [selectedVoicePreview, setSelectedVoicePreview] = useState('');
  const [aiVoiceAudioUrl, setAiVoiceAudioUrl] = useState(section?.url || '');
  const [isElevenLabsApi, setIsElevenLabsApi] = useState(section?.isElevenApi);
  const [elevenLabsAiVoiceID, setElevenLabsAiVoiceID] = useState(section?.elevenLabsAiVoiceId || '');
  const [textUpdated, setTextUpdated] = useState(false);
  const [voiceOver, setVoiceOver] = useState(section?.voiceOver || '');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [transitionValue, setTransitionValue] = useState<string>('fade');
  const [isTransitionOpen, setIsTransitionOpen] = useState(false);
    const {
    ScriptDetails: [scriptDetails, setScriptDetails],
    UserDetail: [userDetail],
    CurrentUserData: [currentUserData],
    SelectedSectionIndex: [selectedSectionIndex, setSelectedSectionIndex],
    StoreUpdatedInBasic: [_, setStoreUpdatedInBasic],
    CurrentlyPlayingSection: [currentlyPlayingSection, setCurrentlyPlayingSection]
  } = useGlobalContext();

  const { data: aiVoiceData, isLoading, isSuccess } = useGetVoices();

  const isSelected = selectedSectionIndex === index;

  useEffect(() => {
    if(scriptDetails.data[index].transition){
      setTransitionValue(scriptDetails.data[index].transition.animation);
    }
  }, [scriptDetails.data[index].transition]);
  // Calculate duration from pages
  const calculateSectionDuration = () => {
    const pages = store.toJSON().pages;
    const sectionPages = pages.filter((page: any) => page?.custom?.scriptIndex === index);
    
    if (sectionPages.length === 0) return { startTime: 0, endTime: 0 };

    // Calculate start time by summing durations of previous sections
    let startTime = 0;
    for (let i = 0; i < index; i++) {
      const prevSectionPages = pages.filter((page: any) => page?.custom?.scriptIndex === i);
      startTime += prevSectionPages.reduce((sum: number, page: any) => sum + (page.duration || 0), 0);
    }

    // Calculate end time by adding current section duration
    const currentSectionDuration = sectionPages.reduce((sum: number, page: any) => sum + (page.duration || 0), 0);
    const endTime = startTime + currentSectionDuration;

    return { startTime, endTime };
  };

  const { startTime, endTime } = calculateSectionDuration();

  // Add this useEffect to sync voiceOver when section changes
  useEffect(() => {
    setVoiceOver(section?.voiceOver || '');
    setSelectedVoiceName(section?.name || '');
    setAiVoiceAudioUrl(section?.url || '');
    setIsElevenLabsApi(section?.isElevenApi);
    setElevenLabsAiVoiceID(section?.elevenLabsAiVoiceId || '');
  }, [section]); // Add section as dependency

  // Handle audio playback
  useEffect(() => {
    if (section?.url) {
      const newAudio = new Audio(section.url);
      newAudio.addEventListener('ended', () => {
        setIsPlaying(false);
        setCurrentlyPlayingSection(null);
      });
      setAudioElement(newAudio);
    }
    
    return () => {
      if (audioElement) {
        audioElement.pause();
        setAudioElement(null);
      }
    };
  }, [section?.url]);

  // Listen for changes in currentlyPlayingSection
  useEffect(() => {
    if (currentlyPlayingSection !== index && isPlaying) {
      setIsPlaying(false);
      if (audioElement) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
    }
  }, [currentlyPlayingSection]);

  

  const handlePlayPause = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!audioElement) return;

    if (isPlaying) {
      audioElement.pause();
      setCurrentlyPlayingSection(null);
    } else {
      // Stop any currently playing audio
      if (currentlyPlayingSection !== null) {
        setCurrentlyPlayingSection(null);
      }
      audioElement.play();
      setCurrentlyPlayingSection(index);
    }
    setIsPlaying(!isPlaying);
  };

  const handleVoiceOverChange = (newText: string) => {
    setVoiceOver(newText);
    setTextUpdated(true);
  };

  const handleVoiceChange = async (value: string) => {
    console.log(value)
    const getCredits = await getUserDetails();
    if (getCredits == -1) {
      message.warning('Something went wrong!');
      return;
    }
    if (getCredits?.voice_limit < 1) {
      message.warning('Voice credits have been exhausted. Please upgrade the plan to use the voice.');
      return;
    }

    // Check if it's a cloned voice
    const clonedVoice = clonedVoices.find((cv: any) => cv.id === value);
    if (clonedVoice) {
      setIsElevenLabsApi(true);
      setElevenLabsAiVoiceID(clonedVoice.voice_id);
      setSelectedVoiceName(clonedVoice.voice_name);
      setSelectedVoicePreview('');
      playVoiceSample(voiceOver, clonedVoice.voice_name, true, clonedVoice.voice_id);
      return;
    }

    const voice = aiVoiceData?.voices?.find((v: any) => v.voice_id === value);
    if (voice) {
      setIsElevenLabsApi(true);
      setElevenLabsAiVoiceID(value);
      setSelectedVoiceName(voice.name);
      setSelectedVoicePreview(voice.preview_url);
      playVoiceSample(voiceOver, voice.name, true, value);
    } else {
      setIsElevenLabsApi(false);
      setSelectedVoiceName(value);
      setSelectedVoicePreview('');
      playVoiceSample(voiceOver, value, false, undefined);
    }
  };

  const playVoiceSample = async (
    text: string,
    aiVoiceName: string,
    isElevenApi: boolean,
    elevenlabsVoiceId: string | undefined
  ) => {
    try {
      setIsAiAudioLoading(true);

      const enhancedText = section?.enhancedVoiceOver;
      
      // Extract only the angle brackets with their content
      const bracketMatch = enhancedText?.match(/<[^>]+>/);
      const emotion = bracketMatch ? bracketMatch[0] : '';
      const newenhancedText = enhancedText ? emotion + ' ' + text : text;
      const BulkAudioCaptionList = await generateElevenLabsPayloads(
        scriptDetails.data, 
        userDetail, 
        setScriptDetails, 
        store, 
        videoStyle, 
        undefined, 
        scriptDetails?.aiVoiceSpeed || 1.0, 
        true,
        index,
        elevenlabsVoiceId || aiVoiceName,
        aiVoiceName,
        isElevenApi ? newenhancedText : text
      );
      const durationMap = new Map(
        BulkAudioCaptionList.map(item => [
          item.sectionIndex, 
          item.output?.newDuration
        ])
      );
            // Update scriptDetails
            setScriptDetails((prevScript: any) => {
              const updatedScript = { ...prevScript };
              const updatedData = [...prevScript.data];
           
              if(enhancedText){
                updatedData[index].enhancedVoiceOver = newenhancedText;
              }
              updatedData[index].voiceOver = voiceOver;
              return { ...updatedScript, data: updatedData };
            });
      const sectionPages = store.pages.filter((page: any) => page.custom?.scriptIndex === index);
      const newDuration = durationMap.get(index);
      sectionPages.forEach((page: any) => {
        page.set({ duration: newDuration });
      });
     
      setIsAiAudioLoading(false);
      setTextUpdated(false);

      try {
        await creditsDeduct('voice_credits', 1);
      } catch (error) {
        console.error('Error deducting credits:', error);
      }

    } catch (error) {
      console.error('Error making text-to-speech request:', error);
      setIsAiAudioLoading(false);
    }
  };

  const aiVoiceDropDown = [
    {
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <StarFilled style={{ color: '#FFD700', fontSize: '14px' }} />

            Premium Voices
          </span>
          <div onClick={(e) => {
            e.stopPropagation();
            setIsDropdownOpen(false);
          }}>
            <VoiceFilterModal
              aiVoice={aiVoiceData?.voices || []}
              handleChangeVoice={handleVoiceChange}
              selectedVoiceName={selectedVoiceName}
            />
          </div>
        </div>
      ),
      options: whisperAiVoiceList.map((voice) => ({
        label: <span>{voice.label.length > 15 ? voice.label.slice(0, 15) + '...' : voice.label}</span>,
        value: voice.value,
      })),
    }
  ];

  // Add cloned voices if available
  if (clonedVoices.length > 0) {
    aiVoiceDropDown.push({
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <StarFilled style={{ color: '#9333ea', fontSize: '14px' }} />
          My Cloned Voices
        </div>
      ),
      options: clonedVoices.map((voice: any) => ({
        label: <span>{voice.voice_name && voice.voice_name.length > 15 ? voice.voice_name.slice(0, 15) + '...' : voice.voice_name || voice.id}</span>,
        value: voice.id,
      })),
    });
  }

  const handleSectionClick = () => {
    setSelectedSectionIndex(index);
    // Find the first page with matching scriptIndex
    const targetPage = store.pages.find((page: any) => page.custom.scriptIndex === index);
    if (targetPage) {
      store.selectPage(targetPage.id);
    //   store.setActiveElementId(targetPage.id);
    }
  };

  const handleDeleteSection = () => {
    if(scriptDetails.data.length === 1){
      message.warning('You cannot delete the last section');
      return;
    }
    const pages = store.toJSON().pages;

    // Filter pages that match the scriptIndex and get their IDs
    const totalCurrentIndexPages = pages
      .filter((page: any) => page?.custom?.scriptIndex === index)
      .map((page: any) => page.id);

    // Delete the pages from the store
    store.deletePages(totalCurrentIndexPages);

    // Update `custom.scriptIndex` for remaining pages
    pages
      .filter((page: any) => page?.custom?.scriptIndex > index)
      .forEach((page: any) => {
        const pageId = page.id;
        const currentPage = store.getElementById(pageId);

        if (currentPage && currentPage.custom) {
          const updatedIndex = currentPage.custom.scriptIndex - 1;
          currentPage.set({ custom: { ...currentPage.custom, scriptIndex: updatedIndex } });
        }
      });

    // Update the script details and remove the section
    setScriptDetails((prevScript: { data: any[] }) => {
      const updatedScript = { ...prevScript };
      const updatedData = [...prevScript.data];
      updatedData.splice(index, 1);
      return { ...updatedScript, data: updatedData };
    });

    // Reset selected section if needed
    if (selectedSectionIndex === index) {
      setSelectedSectionIndex(0); // Set to first section instead of null
    } else if (selectedSectionIndex > index) {
      setSelectedSectionIndex(selectedSectionIndex - 1);
    }

    setStoreUpdatedInBasic(true);
  };

  const handleTransitionValueChange = (selectedValue: string) => {
    const url = transitionAnimationsDropDown.find((item: any) => item.value === selectedValue)?.url;
    setTransitionValue(selectedValue);
    setScriptDetails((prevScript: any) => {
      const updatedScript = { ...prevScript };
      const updatedData = [...prevScript.data];
      updatedData[index] = {
        ...updatedData[index],
        transition: { animation: selectedValue, duration: 30, url:url }
      };
      return { ...updatedScript, data: updatedData };
    });
  };

  const handleTransitionSound = (e: boolean) => {
    setScriptDetails((prevScript: any) => {
      const updatedScript = { ...prevScript };
      const updatedData = [...prevScript.data];
      updatedData[index] = {
        ...updatedData[index],
        transitionSound: e
      };
      return { ...updatedScript, data: updatedData };
    });
  };

  const transitionMenu = (
    <Flex
      vertical
      gap={5}
      style={{
        minWidth: '250px',
        backgroundColor: 'white',
        paddingInline: '8px',
        paddingBlock: '8px',
        borderRadius: '8px',
      }}
    >
      <div>
        <Label>Transition Effect:</Label>
        <TagSelect
          dropdownItems={transitionAnimationsDropDown}
          placeholder={'Wipe'}
          defaultValue={transitionValue}
          onChange={(value) => {
            handleTransitionValueChange(value)
          }}
        />
      </div>
      <Flex gap={10} align='center'>
        <Label>Transition sound:</Label>
        <Switch
          defaultChecked={section?.transitionSound || false}
          value={section?.transitionSound}
          onChange={(e) => handleTransitionSound(e)}
          style={{ marginTop: '4px', width: 'fit-content' }}
        />
      </Flex>
    </Flex>
  );

  return (
    <>
    <div
      key={`section-${index}`}
      onClick={() => handleSectionClick()}
      className={`script-section ${isSelected ? 'selected' : ''}`}
    >
      <div className="section-header">
        <div className="section-title">
          <HolderOutlined />
          Section {index + 1}
        </div>
        <div className="section-actions">
          {isAiAudioLoading ? (
            <LoadingOutlined style={{ color: 'var(--color-primary-600)', fontSize: '14px' }} />
          ) : (
            <>
              {aiVoiceAudioUrl && (
                <div className="play-button" onClick={handlePlayPause}>
                  {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
                </div>
              )}
              <Popconfirm
                title="Delete Section"
                description="Are you sure you want to delete this section? This action cannot be undone."
                onConfirm={(e) => {
                  e?.stopPropagation();
                  handleDeleteSection();
                }}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined
                  className="delete-button"
                  onClick={(e) => e.stopPropagation()}
                />
              </Popconfirm>
            </>
          )}
        </div>
      </div>

      <div className="section-content">
        <TextArea
          value={voiceOver}
          onChange={(e) => handleVoiceOverChange(e.target.value)}
          placeholder={`Enter voiceover text for section ${index + 1}`}
          autoSize={{ minRows: 2, maxRows: 6 }}
        />

        {isSelected && (
          <div className="voice-controls">
            <div className="voice-select-row">
              <AudioOutlined className="voice-icon" />
              <Select
                placeholder="Select a voice"
                value={selectedVoiceName && selectedVoiceName.length > 15 
                  ? `${selectedVoiceName.substring(0, 15)}...` 
                  : selectedVoiceName
                }
                onChange={handleVoiceChange}
                options={aiVoiceDropDown}
                open={isDropdownOpen}
                onDropdownVisibleChange={(visible) => setIsDropdownOpen(visible)}
              />
            </div>
            {/* {selectedVoicePreview && (
              <Button
                type="text"
                icon={<PlayCircleOutlined />}
                onClick={handlePlayPause}
                className="preview-button"
              >
                Preview Voice
              </Button>
            )} */}
          </div>
        )}

        {isSelected && textUpdated && (
          <Button
            type="primary"
            className="update-button"
            disabled={isAiAudioLoading}
            onClick={() => playVoiceSample(voiceOver, selectedVoiceName, isElevenLabsApi, elevenLabsAiVoiceID)}
          >
            Update Voiceover
          </Button>
        )}

        <audio
          data-section={index}
          style={{ display: 'none' }}
          onEnded={() => {
            setIsPlaying(false);
            setCurrentlyPlayingSection(null);
          }}
        />
      </div>
    </div>

    {index < scriptDetails.data.length - 1 && (
      <div className="transition-section">
        <Dropdown
          overlay={transitionMenu}
          trigger={['click']}
          open={isTransitionOpen}
          onOpenChange={setIsTransitionOpen}
        >
          <div className="transition-button">
            {React.createElement(MdOutlineQueueMusic, { size: 16 })}
            <span>Transition</span>
          </div>
        </Dropdown>
      </div>
    )}
    </>
  );
});

export const ScriptPanel = observer(({ store }: any) => {
  const {
    ScriptDetails: [scriptDetails, setScriptDetails],
    StoreUpdatedInBasic: [_, setStoreUpdatedInBasic],
    SelectedSectionIndex: [selectedSectionIndex, setSelectedSectionIndex],
    ActiveSidePanel: [activeSidePanel, setActiveSidePanel],
    UserDetail: [userDetails, setUserDetails]
  } = useGlobalContext();
  const { data: aiVoice, isLoading, isSuccess } = useGetVoices();
  
  const sectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // Add insertScene function
  const handleAddSection = async () => {
    const scriptIndex = scriptDetails.data.length - 1;
    const copyCurrentSection = scriptDetails.data[scriptIndex];

    const pages = store.toJSON().pages;

    // Get all pages with current scriptIndex and their positions
    const currentIndexPages = pages
      .filter((page: any) => page?.custom?.scriptIndex === scriptIndex)
      .map((page: any) => ({
        id: page.id,
        position: pages.findIndex((p: any) => p.id === page.id),
      }))
      .sort((a: any, b: any) => a.position - b.position);

    // Find the last position of current scriptIndex pages
    const lastPosition = currentIndexPages[currentIndexPages.length - 1]?.position || 0;

    // Update scriptIndex for all pages after the insertion point
    pages.forEach((page: any) => {
      if (page.custom.scriptIndex > scriptIndex) {
        const newScriptIndex = page.custom.scriptIndex + 1;
        store.getElementById(page.id).set({
          custom: { ...page.custom, scriptIndex: newScriptIndex },
        });
      }
    });

    // Clone pages and insert them after the last current scriptIndex page
    let insertPosition = lastPosition + 1;
    currentIndexPages.forEach(({ id }: any) => {
      const ClonedPageId = generateUniqueId();
      store.getElementById(id).clone({ id: ClonedPageId });
      const clonedPage = store.getElementById(ClonedPageId);

      // Set new scriptIndex and position
      clonedPage.set({
        custom: { scriptIndex: scriptIndex + 1 },
      });

      // Set the z-index for proper page ordering
      store.getElementById(ClonedPageId).setZIndex(insertPosition);
      insertPosition++;
    });

    // Update script details
    setScriptDetails((prevScript: { data: any[] }) => {
      const updatedScript = { ...prevScript };
      const updatedData = [...prevScript.data];
      const newScene = { ...copyCurrentSection, adBlockType: 'Custom' };
      updatedData.splice(scriptIndex + 1, 0, newScene);
      return { ...updatedScript, data: updatedData };
    });

    // Set the selected section to the newly added section
    const newSectionIndex = scriptIndex + 1;
    setSelectedSectionIndex(newSectionIndex);

    // Select one of the pages from the new section
    const newSectionPages = store.pages.filter((page: any) => page.custom.scriptIndex === newSectionIndex);
    if (newSectionPages.length > 0) {
      store.selectPage(newSectionPages[0].id);
    }

    setStoreUpdatedInBasic(true);

    // Wait for the DOM to update before scrolling
    setTimeout(() => {
      if (sectionRefs.current[`section-${newSectionIndex}`]) {
        sectionRefs.current[`section-${newSectionIndex}`]?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }, 100);
  };

  // Add useEffect to handle scrolling when selectedSectionIndex changes
  useEffect(() => {
    if (selectedSectionIndex !== null && sectionRefs.current[`section-${selectedSectionIndex}`]) {
      sectionRefs.current[`section-${selectedSectionIndex}`]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedSectionIndex]);

  const handleDragEnd = (result: any) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    if (sourceIndex === destinationIndex) return;

    // Get all pages from store
    const pages = store.toJSON().pages;
    
    // Group pages by their current scriptIndex (section)
    const pagesBySection: { [key: number]: any[] } = {};
    pages.forEach((page: any) => {
      const scriptIndex = page?.custom?.scriptIndex ?? 0;
      if (!pagesBySection[scriptIndex]) {
        pagesBySection[scriptIndex] = [];
      }
      pagesBySection[scriptIndex].push(page);
    });

    // Create an ordered array of all sections
    const sectionKeys = Object.keys(pagesBySection).map(Number).sort((a, b) => a - b);
    
    // Reorder sections array to reflect the drag operation
    const reorderedSections = [...sectionKeys];
    const [movedSectionKey] = reorderedSections.splice(sourceIndex, 1);
    reorderedSections.splice(destinationIndex, 0, movedSectionKey);

    // Create a flat array of all pages in the new order
    const reorderedPages: any[] = [];
    reorderedSections.forEach((sectionKey, newSectionIndex) => {
      const sectionPages = pagesBySection[sectionKey] || [];
      // Sort pages within section by their imageIndex to maintain internal order
      sectionPages.sort((a, b) => (a.custom?.imageIndex || 0) - (b.custom?.imageIndex || 0));
      
      sectionPages.forEach((page) => {
        reorderedPages.push({
          ...page,
          newScriptIndex: newSectionIndex
        });
      });
    });

    // Update all pages with new z-index and scriptIndex
    reorderedPages.forEach((pageData, globalIndex) => {
      const element = store.getElementById(pageData.id);
      if (element) {
        // Update z-index based on global position
        element.setZIndex(globalIndex);
        
        // Update scriptIndex to reflect new section position
        element.set({
          custom: {
            ...pageData.custom,
            scriptIndex: pageData.newScriptIndex
          }
        });
      }
    });

    // Update scriptDetails to reflect the section reordering
    setScriptDetails((prevScript: { data: any[] }) => {
      const updatedScript = { ...prevScript };
      const updatedData = [...prevScript.data];
      const [removed] = updatedData.splice(sourceIndex, 1);
      updatedData.splice(destinationIndex, 0, removed);
      return { ...updatedScript, data: updatedData };
    });

    // Update selectedSectionIndex if needed
    if (selectedSectionIndex === sourceIndex) {
      setSelectedSectionIndex(destinationIndex);
    } else if (
      sourceIndex < destinationIndex &&
      selectedSectionIndex > sourceIndex &&
      selectedSectionIndex <= destinationIndex
    ) {
      setSelectedSectionIndex(selectedSectionIndex - 1);
    } else if (
      sourceIndex > destinationIndex &&
      selectedSectionIndex >= destinationIndex &&
      selectedSectionIndex < sourceIndex
    ) {
      setSelectedSectionIndex(selectedSectionIndex + 1);
    }

    // Force re-render
    setStoreUpdatedInBasic(true);

    // Select one of the pages from the moved section
    const movedPages = store.pages.filter((page: any) => page.custom.scriptIndex === destinationIndex);
    if (movedPages.length > 0) {
      store.selectPage(movedPages[0].id);
    }
  };

  // Add useEffect to sync section states when scriptDetails changes
  useEffect(() => {
    if (scriptDetails?.data) {
      scriptDetails.data.forEach((section: any, index: number) => {
        const targetPage = store.pages.find((page: any) => page.custom.scriptIndex === selectedSectionIndex);
        if (targetPage) {
          store.selectPage(targetPage.id);
        }
      });
    }
  }, [scriptDetails]);

  useEffect(()=>{
    setActiveSidePanel(store.openedSidePanel)
  },[])
  const [clonedVoicesData, setClonedVoicesData] = useState<any[]>([]);
  useEffect(()=>{
    async function fetchClonedVoices() {
      const clonedVoicesData = await getClonedVoices();
      setClonedVoicesData(clonedVoicesData);
    }
    fetchClonedVoices();
  },[])
  return (
    <div className="script-panel-container">
      <div className="header">
        <div className="title-row">
          <h1>Script</h1>
          <Button
            type="text"
            icon={<PlusOutlined />}
            onClick={handleAddSection}
            className="add-section-btn"
            title="Add section"
          />
        </div>
      </div>
      
      <div className="sections-container">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="sections">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="sections-list"
              >
                {scriptDetails?.data?.map((section: any, index: number) => (
                  <Draggable 
                    key={`section-${index}`} 
                    draggableId={`section-${index}`} 
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={(el) => {
                          sectionRefs.current[`section-${index}`] = el;
                          provided.innerRef(el);
                        }}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          opacity: snapshot.isDragging ? 0.8 : 1,
                        }}
                      >
                        <div {...provided.dragHandleProps}>
                          <ScriptVoiceSection
                            section={section}
                            index={index}
                            store={store}
                            aiVoice={aiVoice}
                            voiceOverVolume={100}
                            videoStyle="Simple"
                            clonedVoices={clonedVoicesData}
                          />
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
});

export const CustomScriptPanel = {
  name: 'script-panel',
  Tab: (props: any) => (
    <SectionTab name="Script" {...props}>
        <BookOpen02Icon />
      </SectionTab>
  ),
  Panel: ScriptPanel,
};